const quickLinks = [
  { href: '#featured', label: '今日精选' },
  { href: '#ranking', label: '排行榜' },
  { href: '#latest', label: '最新大片' },
  { href: '#genres', label: '分类找片' },
  { href: '#editor', label: '编辑推荐' },
  { href: '#faq', label: '常见问题' },
];

const genreLinks = ['动作', '科幻', '悬疑', '剧情', '动画', '喜剧', '爱情', '犯罪'];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="mx-auto w-full max-w-[1200px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="flex flex-col gap-4 md:col-span-5">
            <a href="#top" className="flex items-center gap-2 font-heading text-xl font-black text-background-50">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-film-line text-lg" aria-hidden="true" />
              </span>
              神马电影
            </a>
            <p className="max-w-md text-sm leading-relaxed text-background-100/80">
              一个集推荐、榜单与分类筛选于一体的电影选片导航页。最新大片、高分佳作与口碑片单在这里一次看全，
              帮你省去翻找时间，轻松发现下一部想看的电影。
            </p>
            <div className="mt-1 flex flex-wrap gap-2">
              {['每日更新', '高分筛选', '类型速查'].map((tag) => (
                <span
                  key={tag}
                  className="rounded-full border border-background-50/20 px-3 py-1 font-label text-xs text-background-100/90"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-4 md:col-span-3">
            <h3 className="font-heading text-sm font-bold text-accent-300">快速导航</h3>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 md:grid-cols-1">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="font-label text-sm text-background-100/80 transition-colors duration-200 hover:text-accent-300"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="flex flex-col gap-4 md:col-span-4">
            <h3 className="font-heading text-sm font-bold text-accent-300">热门类型</h3>
            <div className="flex flex-wrap gap-2">
              {genreLinks.map((genre) => (
                <a
                  key={genre}
                  href="#genres"
                  className="rounded-md border border-background-50/20 px-3 py-1.5 font-label text-xs text-background-100/85 transition-colors duration-200 hover:border-accent-400 hover:text-accent-300"
                >
                  {genre}片
                </a>
              ))}
            </div>
            <p className="mt-2 text-xs leading-relaxed text-background-100/60">
              提示：本页片单为示例内容，用于展示推荐与筛选的浏览体验。
            </p>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-50/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-label text-xs text-background-100/70">神马电影 · 找片不迷路 · 每日更新片单</p>
          <a
            href="#top"
            className="inline-flex w-fit items-center gap-1.5 whitespace-nowrap font-label text-xs text-background-100/80 transition-colors duration-200 hover:text-accent-300"
          >
            <i className="ri-arrow-up-line" aria-hidden="true" />
            回到顶部
          </a>
        </div>
      </div>
    </footer>
  );
}